import React from "react";
import {
  Box,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  styled,
} from "@mui/material";
import Link from "next/link";
import { primary } from "../../../constants/theme";

const CustomPricingTable = styled(Box)(({ theme }) => ({
  width: "84%",
  margin: "40px auto",
  "&.inline": {
    width: "100%",
    margin: "0",
  },
  ".content-heading2": {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "20px",
  },
  [theme.breakpoints.down("md")]: {
    width: "100%",
    padding: "0 12px",
    "&.inline": {
      padding: "0",
    },
    ".content-heading2": {
      fontSize: "24px",
    },
  },
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: "0 12px",
    "&.inline": {
      padding: "0",
    },
    ".content-heading2": {
      fontSize: "20px",
    },
  },
}));

const PricingTable = ({ 
  heading, 
  columns, // Array of { key, label }
  data, // Array of objects with data matching column keys
  inline = false 
}) => {
  return (
    <CustomPricingTable className={inline ? "inline" : ""}>
      {heading && (
        <Typography variant="h2" className="content-heading2">
          {heading}
        </Typography>
      )}

      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          overflowX: "auto",
        }}
      >
        <Table
          sx={{ 
            minWidth: { xs: 600, sm: 800 },
            "& .MuiTableCell-root": {
              borderRight: "1px solid #e0e0e0",
              "&:last-child": {
                borderRight: "none",
              }
            }
          }}
          aria-label="pricing table"
        >
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
              {columns.map((column) => (
                <TableCell
                  key={column.key}
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: "12px", md: "16px" },
                    color: "#000",
                    padding: { xs: "12px 8px", md: "16px" },
                  }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                sx={{
                  "&:last-child td, &:last-child th": { borderBottom: 0 },
                  "&:nth-of-type(even)": { backgroundColor: "#fafafa" },
                  "&:hover": { backgroundColor: "#f0f0f0" },
                }}
              >
                {columns.map((column, colIndex) => (
                  <TableCell
                    key={column.key}
                    component={colIndex === 0 ? "th" : "td"}
                    scope={colIndex === 0 ? "row" : undefined}
                    sx={{
                      fontSize: { xs: "12px", md: "16px" },
                      color: "#000",
                      fontWeight: 400,
                      padding: { xs: "10px 8px", md: "12px 16px" },
                    }}
                  >
                    {column.render ? (
                      column.render(row[column.key], row)
                    ) : column.key === "model" && row.link ? (
                      <Link
                        href={row.link}
                        style={{
                          color: "#000",
                          textDecoration: "underline",
                          fontWeight: 400,
                        }}
                      >
                        {row[column.key]}
                      </Link>
                    ) : row[column.key] ? (
                      row[column.key]
                    ) : (
                      "-"
                    )}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CustomPricingTable>
  );
};

export default PricingTable;

